import React from 'react';
import { Ban } from 'lucide-react';
import { Typography } from '@/components/common';

export const FailedPhaseBody: React.FC = () => (
	<div className="min-h-[280px] flex flex-col items-center justify-center py-8">
		<div className="w-24 h-24 rounded-full bg-purple-150/10 flex items-center justify-center mb-6 border-2 border-[#8039DF26]">
			<Ban className="w-8 h-8 text-purple-150" />
		</div>
		<Typography type="semibold-24" className="text-center">
			Verification Failed
		</Typography>
		<Typography
			type="regular-16"
			className="text-center text-gray-35 mt-2 max-w-lg"
		>
			Your identity could not be confirmed. For security reasons, your access to
			this case has been suspended.
		</Typography>
		<div className="w-full rounded-2xl border border-[#FECACA] px-4 py-4 mt-12">
			<Typography type="semibold-14" className="!text-left">
				We weren&apos;t able to verify your identity
			</Typography>
			<Typography type="regular-14" className="text-gray-35 !text-left mt-1">
				We&apos;re sorry to share that we couldn&apos;t confirm your identity
				using the information provided. Because of this, we&apos;re unable to
				move forward with representing you in this case. We understand this may
				be disappointing or unexpected news, and we&apos;re sorry for any
				inconvenience this causes.
			</Typography>
		</div>
	</div>
);

interface FailedPhaseFooterProps {
	redirectSeconds: number;
}

export const FailedPhaseFooter: React.FC<FailedPhaseFooterProps> = ({
	redirectSeconds,
}) => (
	<div className="flex justify-center">
		<div className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#FECACA]">
			<span className="w-2 h-2 rounded-full bg-main-red animate-pulse" />
			<Typography type="regular-14" className="text-gray-35">
				Redirecting to login in{' '}
				<span className="font-semibold text-black">{redirectSeconds}</span> s
			</Typography>
		</div>
	</div>
);
